import { configureStore as _configureStore, getDefaultMiddleware } from '@reduxjs/toolkit'
import {
  FLUSH,
  PAUSE,
  PERSIST,
  PersistConfig,
  persistReducer,
  persistStore,
  PURGE,
  REGISTER,
  REHYDRATE,
} from 'redux-persist'
import * as Sentry from '@sentry/react'

import { __DEV__ } from 'appConfig'
import rootReducer from 'redux/rootReducer'
import storage from './storage'

export const configureStore = (key = 'root'): any => {
  const persistConfig: PersistConfig<any> = {
    key,
    storage,
    throttle: 500,
    version: 6,
  }

  const persistedReducer = persistReducer(persistConfig, rootReducer)

  const sentryReduxEnhancer = Sentry.createReduxEnhancer({
    stateTransformer: (state) => {
      const transformedState = {
        user_id: state.quiz.id,
      }

      return transformedState
    },
  })

  const store = _configureStore({
    reducer: persistedReducer,
    middleware: [
      ...getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
        },
      }),
    ],
    devTools: __DEV__,
    enhancers: [sentryReduxEnhancer],
  }) as any

  const persistor = persistStore(store)

  return { store, persistor }
}
